import React, { useState } from "react";
import { Box, TextField, Button, Typography, Stack, IconButton } from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import DeleteIcon from "@mui/icons-material/Delete";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

function BuyingForm() {
    const { handleSubmit, control, reset, formState: { errors } } = useForm();
    const [images, setImages] = useState([]);
  
    const onSubmit = async (data) => {
      const formData = new FormData();
      formData.append("name", data.name);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("productName", data.productName);
      formData.append("description", data.description);
      formData.append("price", data.price || "Hinta ei määritelty");
      images.forEach(image => {
        formData.append("images", image.file);
      });
  
      try {
        await axios.post(apiUrl +'/api/send-mail-buyying', formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("Tietosi on lähetetty onnistuneesti!");
        reset();
        setImages([]);
      } catch (error) {
        alert("Lähetys epäonnistui, yritä uudelleen.");
      }
    };

    const resizeImage = (file, maxWidth = 800, maxHeight = 800, quality = 0.7) => {
        return new Promise((resolve) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;
            img.onload = () => {
              const canvas = document.createElement("canvas");
              let width = img.width;
              let height = img.height;
      
              // Oranı koruyarak boyutlandır
              if (width > maxWidth || height > maxHeight) {
                if (width > height) {
                  height *= maxWidth / width;
                  width = maxWidth;
                } else {
                  width *= maxHeight / height;
                  height = maxHeight;
                }
              }
      
              canvas.width = width;
              canvas.height = height;
              const ctx = canvas.getContext("2d");
              ctx.drawImage(img, 0, 0, width, height);
      
              // Küçültülmüş resmi Base64 formatına çevir
              canvas.toBlob(
                (blob) => {
                  const resizedFile = new File([blob], file.name, {
                    type: "image/jpeg",
                    lastModified: Date.now(),
                  });
                  resolve(resizedFile);
                },
                "image/jpeg",
                quality
              );
            };
          };
        });
      };
      
    const handleImageUpload = async (event) => {
        const files = event.target.files;
        if (files.length + images.length > 5) {
          alert("Voit ladata enintään 5 kuvaa!");
          return;
        }
      
        const resizedImages = await Promise.all(
          Array.from(files).map(async (file) => {
            const resizedFile = await resizeImage(file); // 📌 Resmi küçült
            return {
              file: resizedFile,
              preview: URL.createObjectURL(resizedFile),
            };
          })
        );
      
        setImages([...images, ...resizedImages]);
      };
  
    const removeImage = (index) => {
      setImages(images.filter((_, i) => i !== index));
    };
  
    return (
      <Box sx={{ maxWidth: "600px", margin: "auto", mt:{xs:'5vh', md:'15vh'}, p: 3, boxShadow: 3, borderRadius: 2 }}>
        <Typography variant="h4" color='error' sx={{ mb: 3, textAlign: "center" }}>Lahjoita tai Myy Tuotteesi</Typography>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Stack spacing={2}>
            <Controller
              name="name"
              control={control}
              rules={{ required: "Anna nimesi" }}
              render={({ field }) => <TextField {...field} label="Nimi" error={!!errors.name} helperText={errors.name?.message} />}
            />
            <Controller
              name="email"
              control={control}
              rules={{ required: "Sähköposti vaaditaan", pattern: { value: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/, message: "Anna kelvollinen sähköposti" } }}
              render={({ field }) => <TextField {...field} label="Sähköposti" error={!!errors.email} helperText={errors.email?.message} />}
            />
            <Controller
              name="phone"
              control={control}
              rules={{ required: "Puhelinnumero vaaditaan" }}
              render={({ field }) => <TextField {...field} label="Puhelinnumero" error={!!errors.phone} helperText={errors.phone?.message} />}
            />
            <Controller
              name="productName"
              control={control}
              rules={{ required: "Tuotteen nimi vaaditaan" }}
              render={({ field }) => <TextField {...field} label="Tuotteen nimi" error={!!errors.productName} helperText={errors.productName?.message} />}
            />
            <Controller
              name="description"
              control={control}
              rules={{ required: "Anna tuotteen kuvaus" }}
              render={({ field }) => <TextField {...field} label="Tuotteen kuvaus" multiline rows={4} error={!!errors.description} helperText={errors.description?.message} />}
            />
            <Controller
              name="price"
              control={control}
              render={({ field }) => <TextField {...field} label="Hinta (valinnainen)" />}
            />
            <Box>
              <Typography variant="body1" sx={{ mb: 1 }}>Lataa kuvia (Enintään 5)</Typography>
              <input type="file" accept="image/*" multiple hidden id="upload-image" onChange={handleImageUpload} />
              <label htmlFor="upload-image">
                <Button variant="contained" color='success' component="span" startIcon={<AddPhotoAlternateIcon />}>Lisää kuva</Button>
              </label>
              <Stack direction="row" spacing={1} sx={{ mt: 2, flexWrap: "wrap" }}>
                {images.map((img, index) => (
                  <Box key={index} sx={{ position: "relative", display: "inline-block" }}>
                    <img src={img.preview} alt="preview" width={80} height={80} style={{ borderRadius: "5px" }} />
                    <IconButton size="small" onClick={() => removeImage(index)} sx={{ position: "absolute", top: 0, right: 0, backgroundColor: "rgba(0,0,0,0.5)" }}>
                      <DeleteIcon sx={{ color: "white" }} />
                    </IconButton>
                  </Box>
                ))}
              </Stack>
            </Box>
            <Button type="submit" variant="contained" color='info' size="large">Lähetä</Button>
          </Stack>
        </form>
      </Box>
    );
  }

export default BuyingForm;
